export default function PixelPanel({ children, variant = "cream", className = "", ...rest }) {
  const v = variant === "dark" ? "pixel-panel-dark" : "pixel-panel";
  return (
    <div className={`${v} ${className}`} {...rest}>
      {children}
    </div>
  );
}
